import { HttpContextToken } from '@angular/common/http';

/**
 * Indique qu'un appel de lecture facultatif ne doit pas, à lui seul, vider la
 * session locale si son renouvellement échoue. Le 401 reste propagé au
 * composant afin qu'il affiche un état contextualisé.
 */
export const PRESERVE_SESSION_ON_AUTH_FAILURE = new HttpContextToken<boolean>(() => false);
